<template>
  <div class="ab-server warp">
    <div class="block-title" data-aos="fade">版本说明</div>
    <div class="block-subtitle" data-aos="fade" data-aos-delay="100">
      满足不同阶段企业需求
    </div>
    <div class="server-list" id="server-list">
      <!--<a-affix :offset-top="top" style="z-index: 999">-->
      <div class="server-price" id="server-price">
        <a-row>
          <a-col :span="4">
            <div class="server-pro">
              <span class="fontsize20">功能介绍</span>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="price-val flex-col justify-between">
              <div class="item-name fontsize22">体验版</div>
              <div class="ititem-price fontsize24">限时体验</div>
              <!-- <div> -->
              <div class="item-try-btn">
                <Abbutton
                  ><a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
              <!-- </div> -->
            </div>
          </a-col>
          <a-col :span="4">
            <div class="price-val flex-col justify-between">
              <div class="item-name fontsize22">体验版 (认)</div>
              <div class="ititem-price fontsize24">限时体验</div>
              <!-- <div> -->
              <div class="item-try-btn">
                <Abbutton
                  ><a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
              <!-- </div> -->
            </div>
          </a-col>

          <a-col :span="4">
            <div class="price-val flex-col justify-between">
              <div class="item-name fontsize22">营销版 <em>推荐</em></div>
              <div class="ititem-price fontsize24">
                <span>¥</span> 5000 <span class="fontsize14">(年)</span> 套餐
              </div>
              <div class="item-try-btn">
                <Abbutton
                  ><a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
            </div>
          </a-col>
          <a-col :span="4">
            <div class="price-val flex-col justify-between">
              <!-- <div class="item-name fontsize22">营销版 <em>推荐</em></div> -->
              <div class="item-name fontsize22">铂金版</div>
              <div class="ititem-price fontsize24">
                <span>¥</span> 8000 <span class="fontsize14">(年)</span> 套餐
              </div>
              <div class="item-try-btn">
                <Abbutton
                  ><a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
            </div>
          </a-col>
          <!-- <a-col :span="4">
            <div class="price-val flex-col justify-between">
              <div class="item-name fontsize22">尊贵版(永久)</div>
              <div class="ititem-price fontsize24">
                <span>¥</span> 28888 <span class="fontsize14"></span> 套餐
              </div>
              <div class="item-try-btn">
                <Abbutton
                  ><a
                     @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
            </div>
          </a-col> -->
          <a-col :span="4">
            <div class="price-val flex-col justify-between">
              <div class="item-name fontsize22">定制版</div>
              <div class="ititem-price fontsize24">满足不同企业需求</div>
              <div class="item-try-btn">
                <Abbutton
                  ><a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >立刻体验</a
                  ></Abbutton
                >
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <!--</a-affix>-->
      <div class="server-desc">
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <div class="desc-name fontsize20">
              <a-icon type="question-circle" />
              增值服务
            </div>
          </div>

          <a-row class="item-row">
            <a-col :span="4">子账号</a-col>
            <a-col :span="4">1个</a-col>
            <a-col :span="4">1个</a-col>
            <a-col :span="4">8个</a-col>
            <a-col :span="4">20个</a-col>
            <!-- <a-col :span="4">50个</a-col> -->
            <a-col :span="4">按需定制</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">新增账号</a-col>
            <a-col :span="4">-</a-col>
            <a-col :span="4">-</a-col>
            <a-col :span="4"><i class="iconfont icon-duidui"></i></a-col>
            <a-col :span="4"><i class="iconfont icon-duidui"></i></a-col>
            <!-- <a-col :span="4"><i class="iconfont icon-duidui"></i></a-col> -->
            <a-col :span="4">按需定制</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">营销邮件数量</a-col>
            <a-col :span="4">10封</a-col>
            <a-col :span="4">200封</a-col>
            <a-col :span="4">60000封</a-col>
            <a-col :span="4">100000封</a-col>
            <!-- <a-col :span="4">80000封</a-col> -->
            <a-col :span="4">按需定制</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">全球电话余额</a-col>
            <a-col :span="4"> - </a-col>
            <a-col :span="4"> - </a-col>
            <a-col :span="4">-</a-col>
            <a-col :span="4">-</a-col>
            <!-- <a-col :span="4">-</a-col> -->
            <a-col :span="4">按需定制</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">存储管理</a-col>
            <a-col :span="4">1G</a-col>
            <a-col :span="4">2G</a-col>
            <a-col :span="4">50G</a-col>
            <a-col :span="4">100G</a-col>
            <!-- <a-col :span="4">100G</a-col> -->
            <a-col :span="4">按需定制</a-col>
          </a-row>
          <!-- <a-row class="item-row">
            <a-col :span="4">通话录音保存时长</a-col>
            <a-col :span="4">7天</a-col>
            <a-col :span="4">30天</a-col>
            <a-col :span="4">180天</a-col>
            <a-col :span="4">360天</a-col>
            <a-col :span="4">360天</a-col>
            <a-col :span="4">按需定制</a-col>
          </a-row> -->
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <div class="desc-name fontsize20">
              <a-icon type="question-circle" />
              基本功能
            </div>
          </div>
          <a-row class="item-row">
            <a-col :span="4">工作台</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">待办日程</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">营销资料</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">实用工具</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <div class="desc-name fontsize20">
              <a-icon type="question-circle" />
              客户管理
            </div>
          </div>
          <a-row class="item-row">
            <a-col :span="4">客户列表</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">建档分类</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">客户管理</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">查重转移</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">公海客户</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
        </div>

        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <div class="desc-name fontsize20">
              <a-icon type="question-circle" />
              商机挖掘
            </div>
          </div>
          <a-row class="item-row">
            <a-col :span="4">海关数据</a-col>
            <a-col :span="4">限时体验</a-col>
            <a-col :span="4">限时体验</a-col>
            <a-col :span="4">按需定制</a-col>
            <a-col :span="4">按需定制</a-col>
            <a-col :span="4">按需定制</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">搜邮寻客</a-col>
            <a-col :span="4">限时体验</a-col>
            <a-col :span="4">限时体验</a-col>
            <a-col :span="4">按需定制</a-col>
            <a-col :span="4">按需定制</a-col>
            <a-col :span="4">按需定制</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">客户智搜</a-col>
            <a-col :span="4">限时体验</a-col>
            <a-col :span="4">限时体验</a-col>
            <a-col :span="4">按需定制</a-col>
            <a-col :span="4">按需定制</a-col>
            <a-col :span="4">按需定制</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">公共询盘</a-col>
            <a-col :span="4">限时体验</a-col>
            <a-col :span="4">限时体验</a-col>
            <a-col :span="4">按需定制</a-col>
            <a-col :span="4">按需定制</a-col>
            <a-col :span="4">按需定制</a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <div class="desc-name fontsize20">
              <a-icon type="question-circle" />
              营销触达
            </div>
          </div>
          <a-row class="item-row">
            <a-col :span="4">普通邮件</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">营销邮件</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>

          <a-row class="item-row">
            <a-col :span="4">全球电话</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <div class="desc-name fontsize20">
              <a-icon type="question-circle" />
              交易档案
            </div>
          </div>
          <a-row class="item-row">
            <a-col :span="4">产品管理</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">报价管理</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>

          <a-row class="item-row">
            <a-col :span="4">订单管理</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">商家管理</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <div class="desc-name fontsize20">
              <a-icon type="question-circle" />
              数据看板
            </div>
          </div>
          <a-row class="item-row">
            <a-col :span="4">数据总览</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">客户分析</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">统计报告</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <div class="desc-name fontsize20">
              <a-icon type="question-circle" />
              协同管理
            </div>
          </div>
          <a-row class="item-row">
            <a-col :span="4">成员设置</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>

          <a-row class="item-row">
            <a-col :span="4">标签设置</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">任务管理</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">云盘共享</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
        </div>
        <div class="server-desc-item">
          <div class="item-desc-name flex-row">
            <div class="desc-name fontsize20">
              <a-icon type="question-circle" />
              安全中心
            </div>
          </div>
          <a-row class="item-row">
            <a-col :span="4">个人信息</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">账号管理</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">绑定/解绑</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
          <a-row class="item-row">
            <a-col :span="4">操作日志</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <a-col :span="4">免费</a-col>
            <!-- <a-col :span="4">免费</a-col> -->
            <a-col :span="4">免费</a-col>
          </a-row>
        </div>
      </div>
    </div>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import Abbutton from "@/components/Abbutton.vue";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import { usePageTracker } from "@/utils/pageTracker";
export default {
  data() {
    return {
      navBarFixed: false,
      abHideElement: false,
      top: 57,
      visible: false,
    };
  },

  mounted() {
    // 事件监听滚动条
    // window.addEventListener('scroll', this.watchScroll);
  },

  destroyed() {
    // 移除事件监听
    // window.removeEventListener('scroll', this.watchScroll);
  },

  methods: {
    // watchScroll() {
    //   // 滚动的距离
    //   let scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   // 容器的高度
    //   let offsetTop = document.querySelector('#server-list').offsetTop;
    //   let offsetHeight = document.querySelector('#server-list').offsetHeight;
    //   let priceHeight = document.querySelector('#server-price').offsetHeight;
    //   offsetTop = parseInt(offsetTop);
    //   offsetHeight = parseInt(offsetHeight);
    //   priceHeight = parseInt(priceHeight);
    //   console.log(
    //     'scrollTop=>',
    //     scrollTop,
    //     '  offsetTop=>',
    //     offsetTop,
    //     ' offsetHeight=',
    //     offsetHeight,
    //     '  差值',
    //     offsetTop + offsetHeight - 100
    //   );
    //   //  滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
    //   // if (scrollTop > offsetTop) {
    //   //   this.navBarFixed = true;
    //   // } else {
    //   //   this.navBarFixed = false;
    //   // }
    //   // if (scrollTop > offsetTop + offsetHeight - priceHeight - 200) {
    //   //   this.abHideElement = true;
    //   // } else {
    //   //   this.abHideElement = false;
    //   // }
    // },
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
  components: {
    Abbutton,
    inquiryModalVue,
  },
};
</script>

<style lang="sass" scoped>

.item-row-opacity{
  opacity: .4
}
 .ant-popover-inner-content{
   p{
     width: 280px;
     display: flex;
    em{
    width: 8px;
    height: 8px;
    background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
    display: inline-block;
    border-radius: 50%;
    position: relative;
    top: 8px;
    margin-right: 8px;
    }
    font-size: 16px;
  }
}
  .ab-fix-nav {
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .ab-hide {
    display: none;
  }

.ab-server{
  background-color: rgba(255, 255, 255, 1);
  padding-top: 81px;
  .block-title{
    height: 55px;
    font-size: 40px;
    font-family: AlibabaPuHuiTiB;
    line-height: 55px;
    text-align: center;
  }

  .block-subtitle{
    text-align: center;
    padding-top: 10px;
    height: 27px;
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    padding-bottom:30px;
    line-height: 27px;
    opacity: 0.8;
  }

  .server-list{
    margin-top: 38px;
    border: 1px solid #D6EAFF;
  }

  .ant-col-4{
    display: block;
    box-sizing: border-box;
    flex: 0 0 auto;
    float: left;
    i.icon-duidui,i.icon-chacha{
      font-size:22px;
      position: relative;
      top: 3px;color: rgb(80, 224, 123);
    }
    i.icon-chacha{
      color:#FA5151
    }
  }

  .ant-affix .server-price{margin-top:23px;}
    .server-price{
    .ant-row{
      background: #fff;
      height: 203px;
    }

    .server-pro{
      height: 200px;
      background: rgba(214, 234, 255, 1);
      text-align: center;
      span{
        width: 79px;
        font-family: AlibabaPuHuiTiM;
        font-weight: normal;
        color: #333646;
        line-height: 200px;
      }
    }
      .price-val{

        height: 200px;
        background: #F4F9FF;
        text-align: center;
        padding-top: 25px;
        padding-bottom: 30px;
         border-left: 3px solid #fff;

        .item-name{
          font-family: AlibabaPuHuiTiM;
          color: #2B68FF;
          line-height: 35px;
          i{
            font-size:14px;
          }
          em{
            width: 40px;
            display:inline-block;
            line-height: 20px;
            font-family: 'Alibaba-PuHuiTi-R';
            background: #50E07B;
            top: -3px;
            position: relative;
            font-size:12px;
            text-align:center;
            color:#fff;
            border-radius: 4px;
          }
        }
        .ititem-price{
          font-family: AlibabaPuHuiTiM;
          font-weight: normal;
          color: #FF6531;
          line-height: 38px;
          .fontsize14{
              font-size:14px;
            }
          span{
            font-size:20px;
          }
        }

        .item-try-btn{
            .ab-btn{
              width:120px;
              height:46px;
              line-height:46px;
              a{
                font-size:18px;
              }
            }
        }
      }
  }

  .server-desc{
    .item-desc-name{
     /*position: sticky;*/
     /*top:280px;z-index: 1;*/
    }
    paadding: 15px 0 0 78px;
    .server-desc-item{
      padding-bottom:10px;
      .item-desc-name{
        height: 60px;
        margin-bottom:10px;
        background: #F4F9FF;
        padding-left: 78px;
        .desc-icon{
          width: 33px;
          position: relative;
          & img{
               position: absolute;
               width:25px;
               top: 17px;
          }
        }
        .desc-name{
          i{
            cursor: pointer
          }
          i:hover{
            color:#fff;
            background:#2B68FF;
            border-radius:50%;
          }
          font-family: AlibabaPuHuiTiM;
          font-weight: normal;
          color: #333646;
          line-height: 60px;
        }
      }

      .item-row{

        overflow-wrap: break-word;
        color: rgba(51, 54, 70, 1);
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-R;
        text-align: left;
        line-height: 30px;
        padding:7px 0px;
        display: block;

        div:nth-child(1){
          padding-left: 78px;
        }

        div:nth-child(n + 2){
          text-align: center;
        }
      }
      .item-remark{
        background: #F4F9FF;
        padding-bottom:30px;

        .block-remark{
          overflow-wrap: break-word;
          color: rgba(51, 54, 70, 1);
          font-size: 16px;
          font-family: Alibaba-PuHuiTi-R;
          text-align: left;
          padding: 10px 0px;
          padding-right:56px;
          div:nth-child(1){
            padding-left: 88px;
          }
        }
      }
    }
  }
}
</style>
